import { render } from "./FriendAdd.vue?vue&type=template&id=c7095a8c"
import script from "./FriendAdd.vue?vue&type=script&lang=js"
export * from "./FriendAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__